import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  packageSetLabel: {
    description: 'Label for the Package Set dropdown shown when "This product ships in multiple packages" is enabled',
    defaultMessage: 'Select Package Set',
    id: 'PgyShe',
  },
  packageSetPlaceholder: {
    description: 'Placeholder for the Package Set dropdown before a set is chosen, when at least one Package Set exists',
    defaultMessage: 'Select One',
    id: 'hdubv9',
  },
  noSavedPackageSetsPlaceholder: {
    description: 'Placeholder for the Package Set dropdown when the seller has no saved Package Sets yet',
    defaultMessage: 'No saved package sets',
    id: 'GI/VLI',
  },
  createPackageSetButtonLabel: {
    description: 'Button label that takes the merchant to create a new Package Set in Settings',
    defaultMessage: 'Create New Package Set',
    id: 'eGxpbV',
  },
});
